import BaseModel from './BaseModel'

export default class User extends BaseModel {
  // ... User-specific methods or overrides ...
}
